import jwtDecode from "jwt-decode"

export const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()
  
    // Prevent the page/container scrolling
    e.stopPropagation()
  
    // Refocus immediately, on the next tick (after the current function is done)
      setTimeout(() => {
        e.target.focus()
    }, 0)
}

export const validateUser = (navigate) =>{
  let token =  localStorage.getItem('Token');
  if(!token){
    navigate('/');
    return false;
  }else{
    let decode = jwtDecode(token);
    if(decode.userType!="user"){
      return false;
    }
  }
  return true;
}


export const extractURLAndEncodedFilename=(url)=> {
  const normalizedURL = url.replace(/[\\/]/g, '/');

  // Split the normalized URL by the last '/'
  const parts = normalizedURL.split('/');
  const filename = parts[parts.length - 1];

  // URL encode the extracted filename
  const encodedFilename = encodeURIComponent(filename.trim());

  // Extract the URL without the filename
  const urlWithoutFilename = normalizedURL.substring(0, normalizedURL.lastIndexOf('/') + 1);

  return {
      url: urlWithoutFilename,
      encodedFilename: encodedFilename
  };
}

export const currencyFormatter = (amount) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",

    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  });

  return formatter.format(amount);
};

export const checkIfAllPartsInvoicedForPO=(purchaseOrder)=>{
  let localAvailableQtyData = {};
  purchaseOrder?.supplierRFQId?.partsData?.forEach((lineItem) => {
    localAvailableQtyData[lineItem._id] = lineItem.qty;
  });
  purchaseOrder?.billsForPurchaseOrder?.forEach((item) => {
    item?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem.partItemId] =
        localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
    });
  });
  let listOfAvailableQtyValues = Object.values(localAvailableQtyData);
  let isAllQtyInvoiced = true;
  if (listOfAvailableQtyValues.some(item => item > 0)) {
    isAllQtyInvoiced = false;
  }
  return isAllQtyInvoiced;
}